



















import { Component, Prop, Vue } from 'vue-property-decorator'
import { Action, Getter } from 'vuex-class'
import { TextFormatting } from '@plugin/Common/mixins/TextFormatting'
import { CrossSellProductInterface } from '@plugin/Common/interfaces/cross-sell/entities/cross-sell-product.interface'

declare global {
  interface Window {
    storeSettings: any
  }
}

@Component
export default class CrossSellMiniCartRecordComponent extends Vue {
  @Getter('products/selectedProduct') selectedProduct
  @Getter('products/selectedCategoryName') selectedCategory
  @Getter('cart/cartItemSubCategory') selectedSubCategory

  @Prop({ default: null })
  public record!: CrossSellProductInterface

  get hidePricing(): boolean {
    return window.storeSettings?.HidePricingOnPromotionalProductTiles
  }

  get inlineStyle(): any {
    const output = {
      backgroundImage: '',
    }
    if (this.record && this.record.imageUrl) {
      output.backgroundImage = `url(${this.record.imageUrl})`
    }
    return output
  }

  get outputPrice(): string {
    if (!this.record || !this.record.price) {
      return ''
    }
    const val = (this.record.price / 1)
      .toFixed(2)
      .toString()
      .replace(/\B(?=(\d{3})+(?!\d))/g, '.')
    return `$${val}`
  }

  get productUrl(): string {
    return this.record ? this.record.url : '/'
  }

  get formattedDescription(): string {
    if (!this.record || !this.record.description) {
      return ''
    }

    const { description } = this.record
    const shortDescription = this.getShortDescription(description)
    const processedDescription = TextFormatting.methods.processStripMarkdown(shortDescription)
    return this.truncateString(processedDescription, 80)
  }

  private getShortDescription(description: string): string {
    let shortDescription = ''
    if (description) {
      if (description.indexOf('|') > -1) {
        shortDescription = description.substring(0, description.indexOf('|')).trim()
      } else {
        shortDescription = description.trim()
      }
    }
    return shortDescription
  }

  private truncateString(value: string, length: number) {
    return value.length <= length ? value : `${value.slice(0, length)} [...]`
  }

  private async sendGA4CrossSellEvent() {
    let listId = 'cross_sell'
    let listName = 'Cross Sell'

    await this.$store.dispatch('cart/persistTempGA4Data', { id: listId, name: listName })

    let productItems = [
      {
        item_list_id: listId,
        item_list_name: listName,
        item_id: this.record.id,
        item_name: this.record.name,
        price: this.record.price,
        item_category: this.selectedCategory,
        item_category2: this.selectedSubCategory,
      },
    ]
    this.sendGA4AnalyticsEvent({
      evtName: 'select_item',
      products: productItems,
    })
  }

  @Action('global/sendGA4AnalyticsEvent') sendGA4AnalyticsEvent
}
